(function iefe(w, d) {
    const comments = d.querySelectorAll('.comment-main-level > .comment-box');

    if (!comments) {
        return;
    }

    comments.forEach((comment) => {
        const reply = comment.querySelector('.comment-btn.reply');

        reply.addEventListener('click', () => {
            setTimeout(() => {
                const cancel = comment.querySelector('.comment-form-close-btn');
                const name = comment.querySelector('#name');
                name.focus();
                cancel.addEventListener('click', () => {
                    setTimeout(() => {
                        reply.focus();
                    }, 0);
                });
            }, 0);
        });
    });
}(window, document));
